(() => {
  const slidesCollection = document.querySelectorAll(
    '.ss-section-collection-list-2 .swiper-slide'
  );

  if (!slidesCollection.length) return;

  slidesCollection.forEach(item => {
    item.addEventListener('click', () => {
      const id = item.dataset.collection;

      slidesCollection.forEach(el => el.classList.remove('active'));
      item.classList.add('active');

      document
        .querySelectorAll(
          '.ss-section-collection-list-2-infor .collection-card-wrapper'
        )
        .forEach(b => b.classList.add('d-none'));

      const target = document.querySelector(
        `.ss-section-collection-list-2-infor 
         .collection-card-wrapper[data-collection="${id}"]`
      );

      target?.classList.remove('d-none');
    });
  });

  slidesCollection[0]?.click();
})();